module.exports = __webpack_public_path__ + "static/media/nextStatusIconGray.354e7b6a.svg";